import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  sendHyroxTicketMail(data) {
    // data: { reservationId, email, firstName, division, couponCode }
    let url = buildUrl("hyrox/admin/send-ticket-mail")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  getHyroxTickets() {
    let url = buildUrl("hyrox/tickets")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  reserveHyroxTicket(ticketId) {
    let url = buildUrl("hyrox/reserve")
    return axios.post(url, { ticketId }, buildOptions()).then((res) => res.data)
  },
  cancelHyroxReservation() {
    let url = buildUrl("hyrox/cancel")
    return axios.post(url, {}, buildOptions()).then((res) => res.data)
  },
  getHyroxAdminReservations() {
    let url = buildUrl("hyrox/admin/reservations")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  updateHyroxStatus(reservationId, status) {
    let url = buildUrl("hyrox/admin/update-status")
    return axios.post(url, { reservationId, status }, buildOptions()).then((res) => res.data)
  },
  loadProblems() {
    let url = buildUrl("intern/forms/problem")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  submitProblemForm(formData) {
    let url = buildUrl("intern/forms/problem")
    return axios.post(url, formData, buildOptions()).then((res) => res.data)
  },
  downloadListCategory(category) {
    let url = buildUrl("intern/lists/" + category + "/entries")

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  downloadListCategoryPublic(category) {
    let url = buildUrl("intern/lists/" + category + "/entries/public")

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  checkListEntry(category) {
    let url = buildUrl("intern/lists/" + category + "/entries/check")

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  downloadLeadCategory(category) {
    let url = buildUrl("intern/leads/" + category + "/entries")

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  createLeadEntry(data) {
    if (!data.category) data.category = "undefined"

    let url = buildUrl("intern/leads/" + data.category + "/entries")
    console.log("posting")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  createListEntry(data) {
    if (!data.category) data.category = "undefined"

    let url = buildUrl("intern/lists/" + data.category + "/entries")
    console.log("posting")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  deleteListEntry(data) {
    if (!data.category) data.category = "undefined"

    let url = buildUrl("intern/lists/" + data.category + "/" + data._id)

    return axios.delete(url, buildOptions()).then((res) => res.data)
  },

  getTowelActionStatus() {
    let url = buildUrl("towel-action/status")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  reserveTowel(quantity) {
    let url = buildUrl("towel-action/reserve")
    return axios.post(url, { quantity }, buildOptions()).then((res) => res.data)
  },
  cancelTowelReservation() {
    let url = buildUrl("towel-action/cancel")
    return axios.post(url, {}, buildOptions()).then((res) => res.data)
  },
  getTowelActionReservations() {
    let url = buildUrl("towel-action/reservations")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  updateTowelReservationStatus(reservationId, status) {
    let url = buildUrl("towel-action/reservations/update-status")
    return axios.post(url, { reservationId, status }, buildOptions()).then((res) => res.data)
  },
  // END: Towel Reservation Action
}
